import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    stroke="currentColor"
    fill="transparent"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M9 7.66667L7 9.66667M7 9.66667L5 7.66667M7 9.66667L7 4.33333M7 13C3.68629 13 1 10.3137 0.999999 7C0.999999 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7C13 10.3137 10.3137 13 7 13Z" />
  </svg>
);
